export default "__VITE_ASSET__Y5czv8Nb__"